import { filter } from 'lodash';
import React, { useState } from 'react';
import { PaginationControl } from 'components/molecules/paginationControl';
import HorizontalCarousel from 'components/templates/horizontalCarouselModule';
import { useViewport } from 'components/templates/viewportProvider';

const BeliefStatements = ({ data, cardData, campaignId, type }) => {
  const { height } = useViewport();
  const matchCase = cardData ? 'Belief Statements' : 'Campaign';
  const [count, setCount] = useState(1);
  const [previousImage, setPreviousImage] = useState(null);
  const [image, setImage] = useState(null);

  const path = data && data.media_path;
  const web = data && data.device && data.device.web;
  const thumbnail = data && data.device && data.device.thumbnail;
  let cmsData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === matchCase
  );
  if (matchCase === 'Campaign') {
    cmsData = filter(
      cmsData,
      extractedData => extractedData.campaign_id === campaignId
    );
  }

  if (cmsData.length === 0) {
    return null;
  }

  let result = {};
  for (let i = 0; i < cmsData.length; i++) {
    result[i + 1] = cmsData[i].cms_page_details[0];
    result[i + 1].heading = cmsData[i].tag_word;
    result[i + 1].sub_heading = result[i + 1].page_title;
    result[i + 1].image_mobile = cmsData[i].mobile_image;
    result[i + 1].image_web = cmsData[i].image;
    result[i + 1].description = result[i + 1].long_content;
  }

  const pageValue = Object.keys(result);

  const next = () => {
    setPreviousImage(`${path}${web}/${result[count].image_web}`);
    if (count < pageValue.length) {
      setCount(count + 1);
      setImage(`${path}${web}/${result[count + 1].image_web}`);
    } else {
      setCount(1);
      setImage(`${path}${web}/${result[1].image_web}`);
    }
  };

  const previous = () => {
    setPreviousImage(`${path}${web}/${result[count].image_web}`);
    if (count > pageValue[0]) {
      setCount(count - 1);
      setImage(`${path}${web}/${result[count - 1].image_web}`);
    } else if (count === 1) {
      setCount(pageValue.length);
      setImage(`${path}${web}/${result[pageValue.length].image_web}`);
    }
  };

  let card_text = (cardData && cardData.length > 0 && cardData[0].name) || '';
  let card_image =
    (cardData && cardData.length > 0 && cardData[0].posterMobile) || '';
  let bannerImageUrl = `${path}${web}/${result[count].image_web}`;
  let thumbnailImage = `${path}${thumbnail}/${result[count].image_web}`;
  if (Object.keys(result).length === 0) {
    return null;
  }

  return (
    <div
      className={
        type === 'campaign'
          ? 'horizontal-module'
          : 'horizontal-module section-container'
      }
      style={{ height }}
    >
      <div className={'section-content'}>
        <HorizontalCarousel
          result={result}
          count={count}
          previous={previous}
          next={next}
          pageValue={pageValue}
          cardTitle={card_text}
          previousImage={previousImage}
          image={image || bannerImageUrl}
          cardImage={card_image}
          thumbnailImage={thumbnailImage}
          displayCount={matchCase === 'Campaign' ? false : null}
          type={type}
        />
      </div>
      <div
        className={
          type === 'campaign' ? 'section-footer paginate' : 'section-footer'
        }
      >
        <PaginationControl
          className={'section-footer-item'}
          theme={'light-theme'}
          onPreviousClick={previous}
          onNextClick={next}
          currentIndex={count}
          total={pageValue.length}
        />
      </div>
    </div>
  );
};

export default BeliefStatements;
